import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;


const Authentication_login = () => {
  const [mfaToken, setMfaToken] = useState('');
  const navigate = useNavigate();

  const handleMfaSubmit = async (e) => {
    e.preventDefault();

    const userId = localStorage.getItem('userId');

    if (!userId) {
      toast.error("Missing user session. Please log in again.");
      return;
    }

    if (!mfaToken.trim()) {
      toast.warning("Please enter the MFA code.");
      return;
    }

    try {
      // Deliberately plain fetch(), not authManager.authenticatedFetch(): that
      // helper auto-refreshes and calls markLoggedIn() on any 401. If the
      // pre-MFA access-token cookie expires while the user is still on this
      // screen, a refresh here would use the still-valid refresh-token cookie
      // to silently mint a new pre-MFA session and flag the user as logged in
      // before MFA is actually satisfied - the JWT carries no MFA-verified
      // claim, so that flag would then let ProtectedRoute admit them. A 401
      // here should just send them back to log in again, not auto-refresh.
      const response = await fetch(`${Base_Url}/users/verify-mfa`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          mfaToken,
          userId
        })
      });

      if (response.status === 401) {
        toast.error("Your session expired before MFA could complete. Please log in again.");
        navigate('/');
        return;
      }

      const data = await response.json();

      if (!response.ok) {
        const errorMsg = data?.message || data?.error?.message || `MFA verification failed.`;
        throw new Error(errorMsg);
      }

      // response.ok is already guaranteed above - the httpOnly auth cookies are
      // set by the backend on this response, so just flip the local "logged in"
      // flag and start the session. (Not gated on data.result?.token - that field
      // is a mobile/backward-compat convenience, not proof of the cookie auth.)
      authManager.markLoggedIn();
      authManager.init();

      toast.success(data.message || "MFA verified successfully!");
      setTimeout(() => {
        navigate('/dashboard');
      }, 3000);
    } catch (error) {
      toast.error(error.message || "MFA verification failed.");
    }
  };

  return (
    <div className='hold-transition login-page accent-custom'>
      <ToastContainer autoClose={3000} />
      <div className="login-box login_div">
        <div className="card card-outline card-primary">
          <div className="card-header text-center">
            <Link to="/" className="login_logo">
              <img src="assets/img/logo.png" alt='logo.png' border={0} />
            </Link>
          </div>
          <div className="card-body d-flex flex-row flex_flow_rowwrap">
            <div className="col-12 col-sm-12 col-md-12">
              <h5 className="login-box-msg mb-2">Authentication</h5>
              <div className="mb-3 text-center">
                Your account is protected with multi-factor authentication (MFA)
              </div>
              <form onSubmit={handleMfaSubmit}>
                <div className="mb-3 text-left fwt_600">
                  MFA code
                </div>
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Code"
                    value={mfaToken}
                    onChange={(e) => setMfaToken(e.target.value)}
                  />
                </div>
                <div className="row">
                  <div className="col-12 mt-3">
                    <button type="submit" className="btn btn-blue btn-block">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Authentication_login
